export default __webpack_public_path__ + "static/assets/f7af5d99063e4c19351a53344f55f218.svg";